/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `pending` - 대기 중
 * `converting` - 변환 중
 * `completed` - 완료
 * `failed` - 실패
 */
export type WavConversionStatusEnum =
  (typeof WavConversionStatusEnum)[keyof typeof WavConversionStatusEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WavConversionStatusEnum = {
  pending: "pending",
  converting: "converting",
  completed: "completed",
  failed: "failed",
} as const;
